module.exports = __webpack_public_path__ + "img/icon333.ea789a30.png";